<template>
  <div>
    <Modal adaptive :click-to-close="false" name="error" class="video-room-modal-error">
      <div class="video-room-modal-error__wrap">
        <div class="video-room-modal-error__icon" />
        <div class="video-room-modal-error__text">
          <slot />
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import useStreams from '@/compositions/useStreams';
import {
  nextTick, onMounted, watch, watchEffect,
} from '@vue/composition-api';

export default {
  name: 'VideoRoomErrorModal',
  setup(props, { root }) {
    onMounted(() => {
      root.$modal.show('error');
    });
  },
};
</script>

<style lang="scss" scoped>
.video-room-modal-error {
  ::v-deep .vm--modal {
    background: transparent !important;
    box-shadow: none !important;
  }

  &__wrap {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: rgba(28, 28, 30, 0.95);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 1rem;
    text-align: center;
    padding: 2rem 1.5rem;
    position: relative;
    gap: 0.75rem;
  }

  &__icon {
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    background: rgba(255, 59, 48, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.25rem;

    &::before {
      content: '!';
      font-size: 1.375rem;
      font-weight: 700;
      color: #FF3B30;
    }
  }

  &__title {
    font-size: 0.9375rem;
    font-weight: 600;
    line-height: 1.3;
    color: rgba(255, 255, 255, 0.9);
    margin: 0;
  }

  &__text {
    max-width: 18rem;
    font-size: 0.8125rem;
    line-height: 1.6;
    color: rgba(255, 255, 255, 0.5);
    margin: 0;
  }
}
</style>
